module.exports = __webpack_public_path__ + "static/media/gr.6a3cf680.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/gr.svg
// module id = 1448
// module chunks = 0